// Custom hook for handling connection testing
import { useState, useCallback } from 'react';
import { useTestCloudConnectionMutation } from '../../../../api';
import { buildTestConnectionPayload } from '../utils/cloudAccountHelpers';

export const useTestConnection = () => {
    const [tested, setTested] = useState(false);
    const [testCloudConnection, { isLoading: testing }] = useTestCloudConnectionMutation();

    const testConnection = useCallback(
        async (cloudType, formData, userOrg) => {
            try {
                const testPayload = buildTestConnectionPayload(cloudType, formData, userOrg);
                const result = await testCloudConnection(testPayload).unwrap();

                setTested(true);
                return { success: true, data: result };
            } catch (error) {
                setTested(false);
                return { success: false, error: error.message || error.data?.message || 'Connection test failed' };
            }
        },
        [testCloudConnection],
    );

    const resetTestConnection = useCallback(() => {
        setTested(false);
    }, []);

    return {
        testing,
        tested,
        testConnection,
        resetTestConnection,
    };
};
